<script setup lang="ts">
import { ref } from 'vue'

interface Notification {
  id: number
  message: string
  isRead: boolean
  createdAt: string
}

const notifications = ref<Notification[]>([
  {
    id: 1,
    message: 'Тут контент сообщения',
    isRead: false,
    createdAt: new Date().toLocaleString(),
  },
])

const menu = ref(false)

function markAsRead(item: Notification) {
  item.isRead = true
}
</script>

<template>
  <v-menu v-model="menu" :close-on-content-click="false">
    <template #activator="{ props }">
      <v-btn
        icon
        v-bind="props"
        size="small"
      >
        <v-icon icon="mdi-bell" size="24" />
      </v-btn>
    </template>
    <v-list slim dark:bg-gray-800>
      <v-list-item
        v-for="item in notifications"
        :key="item.id"
        slim
        @click="markAsRead(item)"
      >
        <template #prepend>
          <v-icon :icon="item.isRead ? 'mdi-email-open' : 'mdi-email'" size="24" />
        </template>
        <v-list-item-title>
          <div v-if="!item.isRead" class="text-body-2 text-grey-darken-1 font-weight-bold mb-1">
            Новое сообщение
          </div>
          <div class="text-body-2 text-grey-darken-1 font-weight-regular mb-1">
            {{ item.message }}
          </div>
          <div class="text-caption text-primary font-weight-medium">
            {{ item.createdAt }}
          </div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
